interface KeyPointProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const KeyPoint: React.FC<KeyPointProps> = ({ title, children, className = '' }) => (
  <div className={`bg-orange-50 border-l-4 border-orange-500 p-4 rounded-r-lg mb-4 ${className}`}>
    <h4 className="font-medium text-gray-900 mb-2">{title}</h4>
    <div className="text-orange-800">{children}</div>
  </div>
); 